import { CreateItemConsumptionDTO } from '../api/api';
import WorkClient from '../api/workClient';

const getItemsForConsumption = (orderId: number) => {
  return WorkClient.getItemsForConsumption(orderId);
};

const consumeItemsFromOrder = (orderId: number | undefined, body: CreateItemConsumptionDTO | undefined) => {
  return WorkClient.consumeItemsOnOrder(orderId, body);
};

const ConsumptionService = {
  getItemsForConsumption,
  consumeItemsFromOrder
};

export default ConsumptionService;
